import dayjs from 'dayjs';
import DATE_FORMAT from '../constants/dateConstants';
import { BUNDLE_TYPES } from '../constants/packagesConstants';

export const getMinAdvanceDaysAhead = (bundleType, {
  minAdvanceAirCarBooking,
  minAdvanceAirHotelBooking,
  minAdvanceAirHotelCarBooking,
}) => {
  switch (bundleType) {
    case BUNDLE_TYPES.AIR_CAR:
      return minAdvanceAirCarBooking;
    case BUNDLE_TYPES.AIR_HOTEL_CAR:
      return minAdvanceAirHotelCarBooking;
    default:
      return minAdvanceAirHotelBooking;
  }
};

export const getMinTripDuration = (bundleType, {
  minTripDurationDefault,
  minTripDurationAirCar,
}) => {
  switch (bundleType) {
    case BUNDLE_TYPES.AIR_CAR:
      return minTripDurationAirCar;
    default:
      return minTripDurationDefault;
  }
};

export const getMinAdvanceDate = (bundleType, marketConfig) => dayjs().add(getMinAdvanceDaysAhead(bundleType, marketConfig), 'days').format(DATE_FORMAT);
export const validateDateIsAfterToday = (value) => {
  const newDate = dayjs(value, DATE_FORMAT);

  if (!value || !newDate.isValid()) {
    return null;
  }

  if (newDate.isBefore(dayjs().startOf('day'))) {
    return null;
  }
  return value;
};
